module.exports = __webpack_public_path__ + "static/media/3. Agua, Resina cristal y óleo, 90 x 120 cm.2020 copy.96cd7708.png";